









import { Component, Mixins } from "vue-property-decorator";
import {
  DrawableObjectMixin
} from "./mixins";

@Component({
})
export default class PositionCorrectObject extends Mixins(
  DrawableObjectMixin
) {
}
